import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { connect } from "react-redux";
import { Field } from "redux-form";
import * as actions from "MODULES/companies/actions";
import {
  form,
  Form as AppForm,
  AutoCompleteField
} from "MODULES/shared/components/Forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { CompanyStatsTooltip } from "MODULES/shared/components";
import {
  APPROVAL_STATUSES,
  RELATED_COMPANY_ID
} from "MODULES/companies/constants";
import validate from "./validate";

export class Form extends React.Component {
  state = {
    company: null
  };

  handleCompanyChange = result => this.setState({ company: result });

  render() {
    const { searchCompanies } = this.props;
    const { company } = this.state;

    return (
      <AppForm {...this.props}>
        <AppForm.Body>
          <FormRow>
            <Col md={12}>
              <Field
                name={RELATED_COMPANY_ID}
                label="Related Company"
                labelChildren={
                  company && (
                    <React.Fragment>
                      &nbsp;&nbsp;
                      <CompanyStatsTooltip company={company} />
                    </React.Fragment>
                  )
                }
                placeholder="Search by typing a company's name or code"
                component={AutoCompleteField}
                search={searchCompanies}
                formatItem={result =>
                  `${result.name} (${APPROVAL_STATUSES[result.vendor_status]
                    .label})`}
                onItemSelected={i => i && this.handleCompanyChange(i)}
                selectedItem={company}
                required
              />
            </Col>
          </FormRow>
        </AppForm.Body>
      </AppForm>
    );
  }
}

Form.propTypes = {
  country: PropTypes.string,
  billing: PropTypes.instanceOf(Map),
  resetStateField: PropTypes.func.isRequired
};

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(actions.createRelatedCompany(data)),
  searchCompanies: filter => dispatch(actions.searchCompanies(filter))
}))(
  form({
    form: "createRelatedCompany",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/RelatedCompanies/Create/Form.jsx